import { useActionData, useLoaderData, useOutletContext } from 'react-router'

import { useLandingPage } from './useLandingPage'
import { useDarkMode } from '~/components/DarkMode/hook'
import { ConsumerLoaderData, RootOutletContext } from '~/types/portal'
import { SpPortalActionData } from '~/types/preview'
import { mergeLandingPagePreviewData } from '~/utils/shared/preview'

export const useConsumerBranding = () => {
  const { isDark } = useDarkMode()

  // if preview is set by param
  const { previewMode } = useLoaderData<ConsumerLoaderData>() || {}
  const isPreviewParam = !!previewMode

  // if preview is set for offline pages via an action
  const { isPreview: isOfflinePreview = false, previewData: offlinePreview = undefined } = useActionData<SpPortalActionData>() || {}

  // if preview is set for the outlet
  const { isPreview: isPreviewOutlet = false, previewData: outletPreview = undefined } = useOutletContext<RootOutletContext>() || {}

  const landingPageData = useLandingPage()

  const mergedPreviewData = (isPreviewParam || isPreviewOutlet || isOfflinePreview) ? mergeLandingPagePreviewData(landingPageData, outletPreview ?? offlinePreview) : landingPageData

  const { accentColor, 
    accentColorDarkMode, 
    name, 
    fontName, 
    heroImageHref, 
    heroImageDarkModeHref, 
    illustrationImageHref, 
    illustrationImageDarkModeHref, 
    logoImageHref, 
    logoImageDarkModeHref, 
    faviconHref, 
    faviconDarkModeHref,
    description } = mergedPreviewData

  const currentAccentColor = isDark() ? accentColorDarkMode : accentColor

  const heroImage = isDark() ? heroImageDarkModeHref : heroImageHref

  const illustrationImage = isDark() ? illustrationImageDarkModeHref : illustrationImageHref

  const logoImage = isDark() ? logoImageDarkModeHref : logoImageHref

  const favicon = isDark() ? faviconDarkModeHref : faviconHref

  return {
    accentColor: currentAccentColor,
    heroImage,
    illustrationImage,
    name,
    fontName,
    description,
    logoImage,
    favicon,
  }
}